import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ErrorDialogComponentComponent } from '@featuresModules/error-dialog-component/error-dialog-component.component';

@Injectable({
  providedIn: 'root'
})

export class errorService {

  constructor(private injector: Injector) { };

  dialogOpen: boolean

  openDialogError(data: Error | HttpErrorResponse): void {
    if (this.dialogOpen == true) return;
    this.dialogOpen = true

    const dialogService = this.injector.get(DialogService);

    const dialogRef = dialogService.open(ErrorDialogComponentComponent, {
      data: data,
      width: '450px',
      modal: true,
      closable: false,
      closeOnEscape: false,
      baseZIndex: 100000,
      styleClass: 'error-dialog-overlay'
    });

    dialogRef.onClose.subscribe(
      () => this.dialogOpen = false
    )

    // Force the error dialog to the absolute top of the stacking context.
    // PrimeNG renders the mask as a direct child of body — we set its z-index inline
    // so it wins over ANY other dialog (Material CDK at 12000, PrimeNG, etc.)
    setTimeout(() => {
      const masks = document.querySelectorAll<HTMLElement>('.p-dialog-mask');
      masks.forEach(mask => {
        if (mask.querySelector('.error-dialog-overlay')) {
          mask.style.zIndex = '999999';
        }
      });
    }, 0);
  }

}
